// Single source for rendering an offer badge/label consistently across
// product cards, product detail and any future surfaces. Percentage/fixed
// offers are localized on the client; the remaining (threshold-style) types
// ship pre-localized labels from the backend (formatProduct.js).
export function offerLabel(offer, t) {
  if (!offer) return '';
  if (offer.type === 'percentage') {
    return t('offerBadgePercent', '{pct}% OFF', {
      pct: Math.round(Number(offer.value) || 0),
    });
  }
  if (offer.type === 'fixed') {
    return t('offerBadgeFixed', 'CHF {amount} OFF', {
      amount: Number(offer.value) || 0,
    });
  }
  return offer.label || '';
}
